import {
  EDITOR_MODE,
  useBlocksConfig,
  useEditorMode,
  useSyncer
} from "@pathwright/blocks-engine"
import { MediaManager } from "@pathwright/legacy-media-manager"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import "react-image-gallery/styles/css/image-gallery.css"
import "../assets/react-image-gallery-overrides.css"
import {
  IconContainer,
  StyledCarousel,
  StyledEditControls,
  StyledThumbnail
} from "../ui"
import { removeImage } from "../utils"
import { SlickCarousel } from "./Carousel"

const ImageThumbnail = ({ src, onRemove, onReplace, showRemove }) => {
  const { contextKey, accountID, userID } = useBlocksConfig()
  const { blocksContext } = useSyncer()
  const mediaStoragePath = blocksContext?.mediaStoragePath

  return (
    <StyledThumbnail style={{ backgroundImage: `url(${src})` }}>
      {showRemove ? (
        <IconContainer onClick={onRemove} style={{ right: 2, left: "auto" }}>
          <Pathicon icon="x" />
        </IconContainer>
      ) : null}
      <MediaManager
        contextKey={contextKey}
        mediaStoragePath={mediaStoragePath}
        mediaType="image"
        onChooseMedia={onReplace}
        userID={userID}
        accountID={accountID}
        renderButton={({ onClick }) => {
          return (
            <IconContainer onClick={onClick}>
              <Pathicon icon="shuffle" />
            </IconContainer>
          )
        }}
      />
    </StyledThumbnail>
  )
}

const CarouselEdit = (props) => {
  const { data, onChange, id: blockID } = props

  const { contextKey, accountID, userID } = useBlocksConfig()
  const { blocksContext } = useSyncer()
  const mediaStoragePath = blocksContext?.mediaStoragePath
  const { mode } = useEditorMode()

  const handleRemoveImage = (index) => () => {
    const { images } = data

    const nextImages = removeImage(images, index)
    if (nextImages) onChange({ images: nextImages })
  }

  const handleSetImage =
    (index) =>
    ({ url: src }) => {
      const nextImages = [...data.images]
      nextImages[index] = { src }
      onChange({ images: nextImages })
    }

  let imageUrls = data.images || []

  // The UI prevents removing the last image, so this is just a safety check
  if (!imageUrls.length) {
    return (
      <BlankSlate>
        <MediaManager
          contextKey={contextKey}
          mediaStoragePath={mediaStoragePath}
          mediaType="image"
          onChooseMedia={handleSetImage(0)}
          userID={userID}
          accountID={accountID}
          buttonText="Add Image"
        />
      </BlankSlate>
    )
  }
  const editControls = (
    <StyledEditControls className="edit-controls">
      <div style={{ display: "flex" }}>
        {imageUrls.map((x, i) => (
          <ImageThumbnail
            src={x.src}
            key={`carousel-image-${blockID}-${i}`}
            showRemove={imageUrls.length > 1}
            onRemove={handleRemoveImage(i)}
            onReplace={handleSetImage(i)}
          />
        ))}

        <MediaManager
          contextKey={contextKey}
          mediaStoragePath={mediaStoragePath}
          mediaType="image"
          onChooseMedia={handleSetImage(imageUrls.length)}
          userID={userID}
          accountID={accountID}
          renderButton={({ onClick }) => {
            return (
              <StyledThumbnail
                style={{
                  cursor: "pointer",
                  border: "1px dashed rgba(255,255,255,.6)"
                }}
                onClick={onClick}
              >
                <Pathicon icon="plus" />
              </StyledThumbnail>
            )
          }}
        />
      </div>
    </StyledEditControls>
  )
  return (
    <StyledCarousel>
      {mode === EDITOR_MODE.EDIT ? editControls : null}
      <SlickCarousel {...props} />
    </StyledCarousel>
  )
}

export default CarouselEdit
